/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * Supervizor APIs
 * Here is the list of the API endpoints of Supervizor. Click on one to display its implementation. 

Some APIs are protected and require a Bearer token in the Authorization header
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  CreateCompanyGroupRequestDto,
  CreateCompanyGroupResponseDto,
  GetCompanyGroupByIdResponseDto,
  GetCompanyGroupListPaginatedParams,
  GetCompanyGroupListPaginatedResponseDto,
  UpdateCompanyGroupRequestDto,
  UpdateCompanyGroupResponseDto
} from '.././model';

import { customAxiosInstance } from '../../axios/axiosInstance';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * @summary List company groups for the organization
 */
export const getCompanyGroupListPaginated = (
    params: GetCompanyGroupListPaginatedParams,
 options?: SecondParameter<typeof customAxiosInstance>,signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<GetCompanyGroupListPaginatedResponseDto>(
      {url: `/company-groups`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetCompanyGroupListPaginatedQueryKey = (params?: GetCompanyGroupListPaginatedParams,) => {
    return [`/company-groups`, ...(params ? [params]: [])] as const;
    }

    
export const getGetCompanyGroupListPaginatedQueryOptions = <TData = Awaited<ReturnType<typeof getCompanyGroupListPaginated>>, TError = null | null>(params: GetCompanyGroupListPaginatedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompanyGroupListPaginated>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCompanyGroupListPaginatedQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCompanyGroupListPaginated>>> = ({ signal }) => getCompanyGroupListPaginated(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCompanyGroupListPaginated>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCompanyGroupListPaginatedQueryResult = NonNullable<Awaited<ReturnType<typeof getCompanyGroupListPaginated>>>
export type GetCompanyGroupListPaginatedQueryError = null | null


export function useGetCompanyGroupListPaginated<TData = Awaited<ReturnType<typeof getCompanyGroupListPaginated>>, TError = null | null>(
 params: GetCompanyGroupListPaginatedParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompanyGroupListPaginated>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCompanyGroupListPaginated>>,
          TError,
          Awaited<ReturnType<typeof getCompanyGroupListPaginated>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCompanyGroupListPaginated<TData = Awaited<ReturnType<typeof getCompanyGroupListPaginated>>, TError = null | null>(
 params: GetCompanyGroupListPaginatedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompanyGroupListPaginated>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCompanyGroupListPaginated>>,
          TError,
          Awaited<ReturnType<typeof getCompanyGroupListPaginated>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCompanyGroupListPaginated<TData = Awaited<ReturnType<typeof getCompanyGroupListPaginated>>, TError = null | null>(
 params: GetCompanyGroupListPaginatedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompanyGroupListPaginated>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List company groups for the organization
 */

export function useGetCompanyGroupListPaginated<TData = Awaited<ReturnType<typeof getCompanyGroupListPaginated>>, TError = null | null>(
 params: GetCompanyGroupListPaginatedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompanyGroupListPaginated>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCompanyGroupListPaginatedQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Create company group
 */
export const createCompanyGroup = (
    createCompanyGroupRequestDto: CreateCompanyGroupRequestDto,
 options?: SecondParameter<typeof customAxiosInstance>,signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<CreateCompanyGroupResponseDto>(
      {url: `/company-groups`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createCompanyGroupRequestDto, signal
    },
      options);
    }
  


export const getCreateCompanyGroupMutationOptions = <TError = null | null | null,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCompanyGroup>>, TError,{data: CreateCompanyGroupRequestDto}, TContext>, request?: SecondParameter<typeof customAxiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createCompanyGroup>>, TError,{data: CreateCompanyGroupRequestDto}, TContext> => {

const mutationKey = ['createCompanyGroup'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createCompanyGroup>>, {data: CreateCompanyGroupRequestDto}> = (props) => {
          const {data} = props ?? {};

          return  createCompanyGroup(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateCompanyGroupMutationResult = NonNullable<Awaited<ReturnType<typeof createCompanyGroup>>>
    export type CreateCompanyGroupMutationBody = CreateCompanyGroupRequestDto
    export type CreateCompanyGroupMutationError = null | null | null

    /**
 * @summary Create company group
 */
export const useCreateCompanyGroup = <TError = null | null | null,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCompanyGroup>>, TError,{data: CreateCompanyGroupRequestDto}, TContext>, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createCompanyGroup>>,
        TError,
        {data: CreateCompanyGroupRequestDto},
        TContext
      > => {

      const mutationOptions = getCreateCompanyGroupMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    /**
 * @summary Get a company group
 */
export const getCompanyGroupById = (
    id: string,
 options?: SecondParameter<typeof customAxiosInstance>,signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<GetCompanyGroupByIdResponseDto>(
      {url: `/company-groups/${id}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetCompanyGroupByIdQueryKey = (id?: string,) => {
    return [`/company-groups/${id}`] as const;
    }

    
export const getGetCompanyGroupByIdQueryOptions = <TData = Awaited<ReturnType<typeof getCompanyGroupById>>, TError = null | null>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompanyGroupById>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCompanyGroupByIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCompanyGroupById>>> = ({ signal }) => getCompanyGroupById(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCompanyGroupById>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCompanyGroupByIdQueryResult = NonNullable<Awaited<ReturnType<typeof getCompanyGroupById>>>
export type GetCompanyGroupByIdQueryError = null | null


export function useGetCompanyGroupById<TData = Awaited<ReturnType<typeof getCompanyGroupById>>, TError = null | null>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompanyGroupById>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCompanyGroupById>>,
          TError,
          Awaited<ReturnType<typeof getCompanyGroupById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCompanyGroupById<TData = Awaited<ReturnType<typeof getCompanyGroupById>>, TError = null | null>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompanyGroupById>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCompanyGroupById>>,
          TError,
          Awaited<ReturnType<typeof getCompanyGroupById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCompanyGroupById<TData = Awaited<ReturnType<typeof getCompanyGroupById>>, TError = null | null>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompanyGroupById>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a company group
 */

export function useGetCompanyGroupById<TData = Awaited<ReturnType<typeof getCompanyGroupById>>, TError = null | null>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompanyGroupById>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCompanyGroupByIdQueryOptions(id,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Update company group
 */
export const updateCompanyGroup = (
    id: string,
    updateCompanyGroupRequestDto: UpdateCompanyGroupRequestDto,
 options?: SecondParameter<typeof customAxiosInstance>,) => {
      
      
      return customAxiosInstance<UpdateCompanyGroupResponseDto>(
      {url: `/company-groups/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateCompanyGroupRequestDto
    },
      options);
    }
  


export const getUpdateCompanyGroupMutationOptions = <TError = null | null | null | null,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCompanyGroup>>, TError,{id: string;data: UpdateCompanyGroupRequestDto}, TContext>, request?: SecondParameter<typeof customAxiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateCompanyGroup>>, TError,{id: string;data: UpdateCompanyGroupRequestDto}, TContext> => {

const mutationKey = ['updateCompanyGroup'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateCompanyGroup>>, {id: string;data: UpdateCompanyGroupRequestDto}> = (props) => {
          const {id,data} = props ?? {};

          return  updateCompanyGroup(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateCompanyGroupMutationResult = NonNullable<Awaited<ReturnType<typeof updateCompanyGroup>>>
    export type UpdateCompanyGroupMutationBody = UpdateCompanyGroupRequestDto
    export type UpdateCompanyGroupMutationError = null | null | null | null

    /**
 * @summary Update company group
 */
export const useUpdateCompanyGroup = <TError = null | null | null | null,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCompanyGroup>>, TError,{id: string;data: UpdateCompanyGroupRequestDto}, TContext>, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateCompanyGroup>>,
        TError,
        {id: string;data: UpdateCompanyGroupRequestDto},
        TContext
      > => {

      const mutationOptions = getUpdateCompanyGroupMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    /**
 * @summary Delete company group by id
 */
export const deleteCompanyGroupById = (
    id: string,
 options?: SecondParameter<typeof customAxiosInstance>,) => {
      
      
      return customAxiosInstance<null>(
      {url: `/company-groups/${id}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteCompanyGroupByIdMutationOptions = <TError = null,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCompanyGroupById>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customAxiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteCompanyGroupById>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteCompanyGroupById'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteCompanyGroupById>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteCompanyGroupById(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteCompanyGroupByIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteCompanyGroupById>>>
    
    export type DeleteCompanyGroupByIdMutationError = null

    /**
 * @summary Delete company group by id
 */
export const useDeleteCompanyGroupById = <TError = null,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCompanyGroupById>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteCompanyGroupById>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteCompanyGroupByIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    